import {EventBusConsumer} from "Core/Common/EventBus/EventBusConsumer";

import {RootProductsPageEvents} from "../Events/RootProductsPageEvents";
import {ImageTableTypes} from "../../../Components/ProductImageViewer/Enums/ImageTableTypes";
import { ImagePreloader } from "../../../../../../Common/Image";
import { LABELS } from "Core/Components/Translation/Locales";
import {IMAGE_SIZE_CLASS_NAME} from "Core/Components/Controls/ProductConfigurator/Constants";

import Template from '../Templates/Product.html';

export class Product extends EventBusConsumer {
    private _imageSize: number;
    private _imageSizeClassName: string;
    _labels: LABELS;
    public Image: string;

    constructor(public Id: number,
                public Name: string,
                public NameTranslated: string,
                image: string,
                public Description: string,
                public GroupId: number,
                public GroupName: string) {
        super();
                        
        this.Image = image ? `api/FilesApi/GetImage/${image}` : null;

        ImagePreloader.Preload(this.Image);

        this._imageSize = null;
        this._imageSizeClassName = null;
        this._labels = LABELS;
    }

    set ImageSize(value: number) {
        this._imageSize = value;
    }

    get ImageSizeClassName(): string{
        return this.GetImageSizeClassName();
    }

    GetImageSizeClassName(){
        const sizeMap = {
            60: IMAGE_SIZE_CLASS_NAME.SIZE_60,
            70: IMAGE_SIZE_CLASS_NAME.SIZE_70,
            80: IMAGE_SIZE_CLASS_NAME.SIZE_80,
            90: IMAGE_SIZE_CLASS_NAME.SIZE_90,
        };

        return this._imageSizeClassName = sizeMap[this._imageSize] || IMAGE_SIZE_CLASS_NAME.SIZE_100;
    }

    get ImageTableType() {
	    return ImageTableTypes.Product;
    }

    GetTemplate() {
        return Template;
    }

    OnClick() {
        this.Select();
    }

    Select() {
        this.DispatchEvent<Product>(RootProductsPageEvents.Selected, this);
    }
}